import React, { useRef } from 'react';
import { motion } from 'motion/react';

export function FinalCTA() {
    const sectionRef = useRef(null);

    return (
        <section
            ref={sectionRef}
            className="relative py-10 sm:py-16 md:py-32 px-5 overflow-hidden"
            style={{
                background: 'linear-gradient(135deg, #093A5B 0%, #0a4d6e 100%)',
            }}
        >
            {/* Particles */}
            <ParticleField />

            {/* Background Orbs */}
            <motion.div
                className="absolute w-[600px] h-[600px] rounded-full blur-3xl opacity-20"
                style={{
                    background: 'radial-gradient(circle, #0F9D92 0%, transparent 70%)',
                    top: '-200px',
                    right: '-200px',
                }}
                animate={{ scale: [1, 1.2, 1], rotate: [0, 90, 0] }}
                transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
            />

            <motion.div
                className="absolute w-[500px] h-[500px] rounded-full blur-3xl opacity-20"
                style={{
                    background: 'radial-gradient(circle, #0F9D92 0%, transparent 70%)',
                    bottom: '-150px',
                    left: '-150px',
                }}
                animate={{ scale: [1, 1.3, 1], rotate: [0, -90, 0] }}
                transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}
            />

            {/* Content */}
            <div className="max-w-[700px] mx-auto text-center relative z-10">
                <motion.h2
                    className="text-white mb-6 FinalCta_label"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    Ready to Transform<br />Your Workflow?
                </motion.h2>

                <motion.p
                    className="text-white/90 mb-12 FinalCta_Class"
                    // style={{ fontSize: '1.375rem', lineHeight: '1.6', fontWeight: 400 }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    Join thousands of teams already using Simplifyte to work smarter, collaborate better, and achieve more.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    <EnhancedCTAButton>
                        Start Free Trial
                    </EnhancedCTAButton>
                </motion.div>
            </div>
        </section>
    );
}

function ParticleField() {
    const particles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 3 + 1,
        duration: Math.random() * 10 + 10,
        delay: Math.random() * 5,
    }));

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {particles.map((particle) => (
                <motion.div
                    key={particle.id}
                    className="absolute rounded-full bg-white"
                    style={{
                        left: `${particle.x}%`,
                        top: `${particle.y}%`,
                        width: `${particle.size}px`,
                        height: `${particle.size}px`,
                    }}
                    animate={{ y: [0, -30, 0], opacity: [0.2, 0.5, 0.2] }}
                    transition={{
                        duration: particle.duration,
                        repeat: Infinity,
                        delay: particle.delay,
                        ease: 'easeInOut',
                    }}
                />
            ))}
        </div>
    );
}

function EnhancedCTAButton({ children }) {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovered, setIsHovered] = React.useState(false);
    const buttonRef = useRef(null);

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        setPosition({ x: x * 0.3, y: y * 0.3 });
    };

    const handleMouseLeave = () => {
        setPosition({ x: 0, y: 0 });
        setIsHovered(false);
    };

    return (
        // <motion.button
        //     ref={buttonRef}
        //     className="bg-white text-[--color-primary] relative overflow-hidden CTA_Button"
        //     style={{
        //         fontSize: '1.125rem',
        //         fontWeight: 600,
        //         padding: '16px 48px',
        //         borderRadius: '50px',
        //         boxShadow: isHovered
        //             ? '0px 12px 40px rgba(0, 0, 0, 0.3), 0 0 0 2px rgba(255, 255, 255, 0.3)'
        //             : '0px 8px 30px rgba(0, 0, 0, 0.2)',
        //     }}
        //     onMouseMove={handleMouseMove}
        //     onMouseEnter={() => setIsHovered(true)}
        //     onMouseLeave={handleMouseLeave}
        //     animate={{
        //         x: position.x,
        //         y: position.y,
        //         scale: isHovered ? 1.08 : 1,
        //     }}
        //     transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        //     whileTap={{ scale: 0.98 }}
        // >
        //     {/* Shimmer */}
        //     <motion.div
        //         className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent"
        //         animate={{ x: ['-200%', '200%'] }}
        //         transition={{ duration: 3, repeat: Infinity, repeatDelay: 2 }}
        //         style={{ width: '50%' }}
        //     />

        //     {/* Border Glow */}
        //     <motion.div
        //         className="absolute inset-0 rounded-full"
        //         style={{
        //             background:
        //                 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)',
        //         }}
        //         animate={{ rotate: isHovered ? 360 : 0 }}
        //         transition={{
        //             duration: 2,
        //             repeat: isHovered ? Infinity : 0,
        //             ease: 'linear',
        //         }}
        //     />

        //     <span className="relative z-10">{children}</span>
        // </motion.button>
        <motion.button
            ref={buttonRef}
            className="bg-white text-[--color-primary] relative overflow-hidden CTA_Button"
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={handleMouseLeave}
            animate={{
                x: position.x,
                y: position.y,
                scale: isHovered ? 1.08 : 1,
            }}
            transition={{ type: 'spring', stiffness: 200, damping: 20 }}
            whileTap={{ scale: 0.98 }}
        >
            {/* Shimmer */}
            <motion.div
                className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent"
                animate={{ x: ['-200%', '200%'] }}
                transition={{ duration: 3, repeat: Infinity, repeatDelay: 2 }}
                style={{ width: '50%' }}
            />

            {/* Border Glow */}
            <motion.div
                className="absolute inset-0 rounded-full"
                style={{
                    background:
                        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)',
                }}
                animate={{ rotate: isHovered ? 360 : 0 }}
                transition={{
                    duration: 2,
                    repeat: isHovered ? Infinity : 0,
                    ease: 'linear',
                }}
            />

            <span className="relative z-10">{children}</span>
        </motion.button>

    );
}
